<template>
  <div>
    <h3>Booking Request</h3>
    <hr />
    <div class="text-left" v-if="getBooking.step === 1">
      <BookingFor />
    </div>
    <div class="text-left" v-else-if="getBooking.step === 2">
      <BookingStudent />
    </div>
    <div class="text-left" v-else-if="getBooking.step === 3">
      <h5 class="my-3">Applicant Information</h5>
      <BookingApplicant />
    </div>
    <div class="text-left" v-else-if="getBooking.step === 4">
      <h5 class="my-3">Applicant Information</h5>
      <BookingApplicantAddress />
    </div>
    <div class="text-left" v-else-if="getBooking.step === 5">
      <h5 class="my-3">Review &amp; Submit</h5>
      <BookingPreview />
    </div>
    <div v-else>
      <b-alert variant="info" :show="true">
        <strong>Oops!</strong> Something went wrong.
        <p class="my-3">
          <b-button
            v-if="getBooking && getBooking.step > 1"
            type="button"
            variant="light"
            @click="back()"
          >
            Go Back
          </b-button>
          <b-button v-else type="button" variant="light" @click="tryAgain()">
            Try Again
          </b-button>
        </p>
      </b-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BookingFor from "./BookingFor";
import BookingStudent from "./BookingStudent";
import BookingApplicant from "./BookingApplicant";
import BookingApplicantAddress from "./BookingApplicantAddress";
//import BookingApplicantPassport from "./BookingApplicantPassport";
//import BookingApplicantEmergency from "./BookingApplicantEmergency";
import BookingPreview from "./BookingPreview";

export default {
  name: "BookingForm",
  components: {
    BookingFor,
    BookingStudent,
    BookingApplicant,
    BookingApplicantAddress,
    //BookingApplicantPassport,
    //BookingApplicantEmergency,
    BookingPreview,
  },
  computed: {
    ...mapGetters(["getBooking"]),
  },
  methods: {
    ...mapActions(["saveBooking"]),
    back() {
      // go back
      if (this.getBooking) {
        let booking = JSON.parse(JSON.stringify(this.getBooking));
        const thisStep = booking.step ? booking.step : 1;

        if (thisStep > 1) booking.step = thisStep - 1;
        this.saveBooking(booking);
      }

      return false;
    },
    tryAgain: () => {
      window.location.reload();
    },
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
